import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { postSystemPageReload } from '@/service/systemControl'
import ReloadClientPagesForm from './ReloadClientPagesForm'

function resolveReloadError (err) {
  if (typeof err === 'string' && err) return err
  return (
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    err?.msg ||
    err?.message ||
    '刷新客户页面失败'
  )
}

class ReloadClientPagesModal extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    width: PropTypes.number,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    children: PropTypes.node
  }

  static defaultProps = {
    title: '刷新客户页面',
    width: 520,
    baseProps: {}
  }

  handleOk = async (form) => {
    const { onSuccess } = this.props
    try {
      const fields = await form.current.validateFields()
      const rawIds = Array.isArray(fields.clientIds) ? fields.clientIds : []
      const clientIds = rawIds
        .map((id) => {
          const n = Number(id)
          return Number.isFinite(n) ? n : id
        })
        .filter((id) => id != null && id !== '')
      if (clientIds.length === 0) {
        message.error('请至少选择一名员工')
        throw new Error('请至少选择一名员工')
      }
      await postSystemPageReload({ clientIds })
      message.success(`已请求刷新 ${clientIds.length} 个客户页面`)
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      if (err?.errorFields) throw err
      message.error(resolveReloadError(err))
      throw err
    }
  }

  render () {
    const { children, baseProps, title, width } = this.props
    const bp = baseProps || {}
    return (
      <WrappedModal
        children={children}
        baseComponent={<ReloadClientPagesForm baseProps={bp} />}
        baseProps={{ ...bp }}
        title={title}
        width={width}
        okText="确认刷新"
        onOk={this.handleOk}
      />
    )
  }
}

export default ReloadClientPagesModal
